import { X } from 'lucide-react'

export interface CloseButtonProps {
  onClick: () => void
  /** Accessible name. */
  label?: string
}

export function CloseButton({ onClick, label = 'Close' }: CloseButtonProps) {
  return (
    <button type="button" className="btn btn-ghost btn-icon close-btn" onClick={onClick} aria-label={label}>
      <X aria-hidden />
    </button>
  )
}
